module.exports = __webpack_public_path__ + "img/computer.5c8f08b5.gif";